module.exports = {
	"api.httpinterceptor.q6n8xn": "请求出错了",
	"api.request.qpc7ar": "url为空",
	"error.link-error.48h4ct": "出错了",
	"error.link-error.232d19": "参数无效：",
	"error.link-error.44gd55": "了解智搭",
	"login.auto-login.qgn7zj": "此账号已在使用，可直接登录",
	"login.auto-login.25v959": "立即登录",
	"login.create-org.5x9f8l": "该账号还未创建组织",
	"login.create-org.21r5sh": "在进入系统前，你需要创建组织才能登录进入",
	"login.create-org.8plaol": "你也可以选择：",
	"login.create-org.21d3fj": "1、更换账号重新登录",
	"login.create-org.g76h7u": "2、直接创建新组织",
	"login.create-org.698vk9": "创建组织",
	"login.create-org.o6sy8f": "返回登录",
	"login.forget-pwd-form.l3v7ay": "忘记密码",
	"login.forget-pwd-form.l112dc": "获取验证码",
	"login.forget-pwd-form.nfdbmd": "确定",
	"login.forget-pwd-form.6b2385": "手机号",
	"login.forget-pwd-form.bh5mmc": "验证码",
	"login.forget-pwd-form.38ykjf": "请输入密码",
	"login.forget-pwd-form.z38j76": "请再次输入密码",
	"login.forget-pwd-form.u4e59h": "请输入手机号码",
	"login.forget-pwd-form.8i833l": "请输入11位手机号码",
	"login.forget-pwd-form.6a0s18": "请输入正确的手机号码",
	"login.forget-pwd-form.ogpkw8": "两次输入密码不一致!",
	"login.forget-pwd-form.lblo1h": "请输入验证码",
	"login.forget-pwd-form.ch4q37": "长度在 6 到 18 个字符",
	"login.forget-pwd-form.9wickx": "秒后重发",
	"login.forget-pwd-form.fo4848": "密码重置成功",
	"login.login-form.3r4v7j": "账号登录",
	"login.login-form.2ggb48": "验证码登录",
	"login.login-form.7469hh": "我已阅读并同意",
	"login.login-form.7k35mt": "《用户协议》",
	"login.login-form.v57f76": "和",
	"login.login-form.4fh3v2": "《隐私政策》",
	"login.login-form.f68387": "没有账号？",
	"login.login-form.4f8kmx": "立即注册",
	"login.login-form.k81141": "不同意",
	"login.login-form.khw9mg": "同 意",
	"login.login-form.r32x8v": "请输入手机号",
	"login.login-form.3ou3jl": "登录中",
	"login.login-form.7dys59": "登录",
	"login.login-form.er7m32": "服务协议及隐私保护",
	"login.login-form.voe6p1": "请输入正确的手机号",
	"login.login-form.p2b47q": "获取权限失败",
	"login.organization-form.ffr26f": "已创建，",
	"login.organization-form.8d4h47": "去登录",
	"login.organization-form.c28qj8": "取消",
	"login.organization-form.j6k616": "创建",
	"login.organization-form.42561l": "组织名称",
	"login.organization-form.2yf5w0": "请输入组织名称",
	"login.organization-form.42lv18": "所属行业",
	"login.organization-form.uo5qu2": "组织地址",
	"login.organization-form.468ed5": "详细地址",
	"login.organization-form.1w9e7q": "请输入详细地址",
	"login.organization-form.593f87": "组织规模",
	"login.organization-form.ol3z15": "请选择组织规模",
	"login.organization-form.4dij6m": "电子邮箱",
	"login.organization-form.46ruo4": "请输入电子邮箱",
	"login.organization-form.433t4x": "组织官网",
	"login.organization-form.hbxo94": "请输入组织官网",
	"login.organization-form.4792wb": "统一社会信用代码",
	"login.organization-form.223s8k": "请输入统一社会信用代码",
	"login.organization-form.1kjk8u": "请选择所属行业",
	"login.organization-form.fp4680": "上传头像图片大小不能超过 2MB!",
	"login.organization-form.neh7n5": "组织创建成功",
	"login.register-form.84p6e2": "欢迎注册",
	"login.register-form.23f2xb": "已有账号？",
	"login.register-form.u87f5r": "直接登录",
	"login.register-form.2i85b6": "注册",
	"login.register-form.is6m7q": "姓名",
	"login.register-form.8330bi": "密码",
	"login.register-form.4l2ie7": "确认密码",
	"login.register-form.86ng42": "请输入姓名",
	"login.register-form.31lw5q": "账户注册成功",
	"login.select-org.730r1v": "返回",
	"login.select-org.3b3q2h": "创建新组织",
	"login.select-org.7q7p85": "选择您已加入的组织",
	"login.select-org.t19w2e": "请在以下多个组织中，选择组织进入",
	"login.select-org.u444bq": "上次登录",
	"components.create-organization.72xnpc": "创建新组织并建立连接，你将成为该组织的组织管理员",
	"components.create-organization.y342cq": "该组织已创建，可分享链接邀请对方同意建立连接。",
	"components.create-organization.3mslgc": "链接地址",
	"components.create-organization.3f8p18": "分享链接",
	"components.create-organization.qgzi5t": "提示",
	"components.create-organization.234egt": "姓名不能包含特殊字符",
	"components.create-organization.8y8hov": "请输入正确的信用代码",
	"components.create-organization.38lfsg": "请输入正确的邮箱地址",
	"components.create-organization.1um050": "修改成功",
	"components.create-organization.685yf4": "机构名称已存在！",
	"components.create-organization.38385x": "请配置智搭平台地址",
	"components.create-organization.k2gz3p": "尊敬的合作伙伴，诚挚邀请你与我建立连接关系，基于「智搭」实现企业间数据填报、流程审批等。期待与你的合作！",
	"components.create-organization.d9toyb": "\\n邀请人：",
	"components.create-organization.g5zaru": "\\n邀请链接：",
	"components.create-organization.4ycqk7": "链接已复制",
	"components.create-organization.ea7r67": "链接复制失败",
	"components.edit-organization.w4f6r5": "编辑组织",
	"components.levels-add-dialog.6i0i7a": "部门名称",
	"components.levels-add-dialog.f155cf": "请输入部门名称",
	"components.levels-add-dialog.td3h61": "上级部门",
	"components.levels-add-dialog.0u49t1": "名称不能为空",
	"components.levels-add-dialog.3y8l6k": "编辑部门",
	"components.levels-add-dialog.n0opre": "新增部门",
	"components.related-app.c73l6q": "关联应用",
	"components.related-app.ki6n24": "应用名称",
	"components.related-app.j5sss3": "请选择应用",
	"components.staff-dialog.35h0xf": "注意：",
	"components.staff-dialog.1880mx": "1.输入的手机号没有注册，则自动注册账号并添加到组织，初始密码为wlw@123456",
	"components.staff-dialog.eo737j": "2.输入的手机号已注册，则直接添加到组织",
	"components.staff-dialog.u6ir43": "设为组织管理员",
	"components.staff-dialog.8j27h5": "取 消",
	"components.staff-dialog.n6alc2": "确 定",
	"components.staff-dialog.f05515": "添加",
	"components.staff-dialog.f6xvja": "编辑",
	"components.staff-dialog.760u28": "保存",
	"components.staff-dialog.h65044": "删除",
	"components.staff-dialog.22f184": "部门",
	"components.staff-dialog.s662ls": "岗位",
	"components.staff-dialog.qozha7": "请选择",
	"components.staff-dialog.7m4es2": "岗位设置",
	"components.staff-dialog.67gji4": "岗位名称",
	"components.staff-dialog.g4ec7x": "请输入岗位名称",
	"components.staff-dialog.bkn111": "操作",
	"components.staff-dialog.35nh68": "姓名不能为空",
	"components.staff-dialog.5e2nc4": "手机号不能为空",
	"components.staff-dialog.b4p7lc": "请选择部门",
	"components.staff-dialog.38g662": "添加成员",
	"components.staff-dialog.w6wp80": "最多添加三十种类型",
	"components.staff-dialog.he0584": "请输入不含特殊字符的岗位名称",
	"components.staff-dialog.q25fz3": "确定删除岗位？",
	"components.staff-dialog.p77gw4": "警告",
	"components.structure.87x93f": "解除连接",
	"components.structure.1rn1sl": "删除部门",
	"components.structure.978u38": "查询",
	"components.structure.bxil03": "重置",
	"components.structure.08dlw6": "人员添加",
	"components.structure.227r0q": "工作台添加",
	"components.structure.tef8j8": "批量删除",
	"components.structure.5749t2": "请输入名称",
	"components.structure.myn2rj": "序号",
	"components.structure.eof9nq": "角色",
	"components.structure.3yh751": "确定删除此部门吗？删除后不可恢复。",
	"components.structure.nm7p8o": "取消部门管理员",
	"components.structure.49rd61": "设置部门管理员",
	"components.structure.6s7iy8": "确定删除此成员？删除后不可恢复。",
	"components.structure.7014jr": "请选择删除人员！",
	"components.structure.j11vpa": "确定批量删除吗？删除后不可恢复。",
	"components.work-platform-dialog.x6sc3u": "全选",
	"components.work-platform-dialog.s7r6b5": "暂无人员",
	"components.work-platform-dialog.hmunnn": "已选",
	"components.work-platform-dialog.6q24xm": "清空",
	"components.work-platform-dialog.9f12j5": "注意：初始密码为wlw@123456",
	"components.work-platform-dialog.m324v5": "添加人员",
	"components.work-platform-dialog.8ai0ei": "搜索部门",
	"components.work-platform-dialog.t9ho62": "请输入关键词搜索",
	"components.work-platform-dialog.s4bk51": "请选择人员",
	"external-structure.index.drfp1p": "暂无外部组织",
	"external-structure.index.78tbs3": "外部组织连接后可以实现线上企业间数据填报、流程审批等协作",
	"external-structure.index.17ph48": "新建连接",
	"external-structure.index.71b088": "确定解除连接？",
	"external-structure.new-structure.ea1mv8": "将下方链接分享给合作伙伴，对方点击即可建立连接关系。",
	"external-structure.new-structure.wt48d7": "链接邀请",
	"manage.index.4h2gu3": "系统管理",
	"manage.index.5r455g": "组织管理",
	"manage.index.i3no7f": "内部组织",
	"manage.index.k75pu4": "外部组织",
	"manage.index.h774xw": "应用配置",
	"manage.index.35ba7b": "产品管理",
	"product-manage.index.uw4vxs": "新增产品",
	"product-manage.index.5s7694": "详情",
	"product-manage.index.1s0v45": "请输入产品名称",
	"product-manage.index.d2d2go": "软件产品名称",
	"product-manage.index.kiwecx": "产品编码",
	"product-manage.index.o4mc35": "管理单元",
	"product-manage.index.2g7xpu": "创建时间",
	"product-manage.index.ebv0c6": "创建人",
	"product-manage.index.50dto8": "产品说明",
	"product-manage.index.8s253c": "获取数据失败",
	"product-manage.productdetail.373uv1": "产品详情",
	"product-manage.productdetail.v5qvv0": "产品名称",
	"product-manage.productdetail.46646r": "管理部门",
	"product-manage.productform.5xi390": "软件产品名称只能由中文、字母、数字、下划线组成，且不能以数字、中划线和下划线开头",
	"product-manage.productform.2n17j3": "编码不能为空",
	"product-manage.productform.luo3w6": "编码只能由小写字母、数字、中划线组成，且必须以字母开头，字母数字结尾",
	"product-manage.productform.8k78h4": "请输入编码",
	"product-manage.productform.2h4q55": "管理单元不能为空",
	"product-manage.productform.804j65": "请输入描述",
	"product-manage.productform.uvfk5u": "新增成功",
	"product-manage.productform.3svm4j": "新增失败",
	"views.login.71to72": "智搭·应用构建工具",
	"views.login.2g8tfn": "面向软件研发全流程生产工具，让软件开发像搭积木一样简单",
	"views.login.hu6fx1": "智数·数据中台",
	"views.login.gwxd27": "数据全生命周期一站式开发运营平台，释放数据价值，驱动业务创新",
	"views.login.tkbs15": "数据标准管理平台",
	"views.login.3ojxy2": "统一标准，精准掌控——让数据治理有章可循",
	"views.login.39h0w7": "软件工厂·全新研发模式",
	"views.login.s8x41t": "企业数字化转型加速器，快速构建你的专属应用",
	"views.login.5ul366": "Copyright@2022中科美络 All Rights Reserved",
	"manage.index.367p5b": "资源监控",
	"manage.index.1m33r8": "日志管理",
	"manage.index.l1ayi6": "系统日志",
	"manage.index.1g13t6": "应用日志",
	"system-log.index.8iz4si": "搜索用户名或ID",
	"system-log.index.61dp1r": "操作时间",
	"system-log.index.tqo7q7": "操作用户",
	"system-log.index.jo781k": "模块名称",
	"system-log.index.603pn2": "行为",
	"operation-log.index.68j126": "请选择产品",
	"operation-log.index.68j127": "请选择应用",
	"operation-log.index.68j128": "请选择行为类型",
	"operation-log.index.68j129": "请选择产品或应用",
	"operation-log.index.1pak36": "至",
	"operation-log.index.hd2sa1": "开始日期",
	"operation-log.index.x8k78r": "结束日期",
	"operation-log.index.cw76nn": "描述",
	"views.login.k42y62": "Copyright © 2025 中科美络低代码一体化开发平台",
	"views.login.46q6n6": "简体中文",
	"system-log.index.6501y8": "导出",
	"system-log.index.keuv7w": "暂无数据可导出",
	"system-log.index.d0g716": "导出成功"
}